import { useDispatch } from "react-redux";
import { importFromYaml } from "../../../../abstract/controller/modelYamlImport";
import { setRoot } from "../../../../abstract/redux/slice/structureSlice";
import ButtonIntroWide from "../../../ui/buttons/ButtonIntroWide";
import ButtonTomatoClose from "../../../ui/buttons/ButtonTomatoClose";
import styles from "./Manual.module.scss";

const id = "logic0";
const idNext = "logic1";

const init = `
functions:
  - function: Default
`;

function ManualLogic0({ tutorial, setTutorial }) {
  if (tutorial === id) {
    return <Core setTutorial={setTutorial} />;
  }

  return null;
}

function Core({ setTutorial }) {
  const _dispatch = useDispatch();

  const handleStartTutorial = () => {
    const { model } = importFromYaml(init);
    _dispatch(setRoot(model, 0));
    setTutorial(idNext);
  };

  const handleClose = () => {
    setTutorial("null");
  };

  return (
    <>
      <div className={`${styles["foreground"]} ${styles["foreground-init"]}  ${styles["overlay"]}`}>
        <ButtonTomatoClose onClick={handleClose} />
        <div className={styles["header"]}>
          <div className={styles["header__assistant"]}></div>
          <div className={styles["header__text--main"]}>
            <p>
              Manual tutorials start from a predefined model. Be sure to export your current model first.
            </p>
          </div>
        </div>
        <div className={styles["confirmation"]}>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="red" title="Go back!" onClick={handleClose} />
          </div>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="tomato" title="Continue" onClick={handleStartTutorial} />
          </div>
        </div>
      </div>
    </>
  );
}

export default ManualLogic0;
